import type { ReactNode } from "react";
import { generatePath, Link } from "react-router-dom";
import routing from "routing";
import type { SearchArticle } from "src/api/search";
import { ArticleView } from "src/components/NewComponents/Search/ArticlesViews/ArticleView";
import ViewWithPagination from "src/components/NewComponents/Search/ViewWithPagination";
import { ArticleSearchItemSkeleton } from "src/components/NewComponents/Skeletons/ArticleSearchItemSkeleton";
import { removePolishSign } from "src/helpers/formatHtmlTag";

const SKELETON_COUNT = 6;

type ArticlesViewsProps = {
	isLoading: boolean;
	articles: SearchArticle[];
	searchValue: string;
	pagesCount: number;
	page: number;
	setPage: (page: number) => void;
	scrollToTop: () => void;
	emptyState: ReactNode;
};

export function ArticlesViews({
	isLoading,
	articles,
	searchValue,
	pagesCount,
	page,
	setPage,
	scrollToTop,
	emptyState,
}: ArticlesViewsProps) {
	if (isLoading) {
		return (
			<div className="flex flex-col gap-12 my-12">
				{Array.from({ length: SKELETON_COUNT }, (_, index) => (
					<ArticleSearchItemSkeleton key={index} />
				))}
			</div>
		);
	}

	if (!articles.length) {
		return emptyState;
	}

	return (
		<ViewWithPagination
			count={pagesCount}
			page={page}
			setPage={setPage}
			scrollToTop={scrollToTop}
		>
			<div className="flex flex-col gap-12 my-12">
				{articles.map((article) => (
					<Link
						key={article.id}
						to={generatePath(routing.paths.article, {
							id: article.id,
							topic: removePolishSign(article.title),
						})}
						className="link-inherit"
					>
						<ArticleView article={article} searchValue={searchValue} />
					</Link>
				))}
			</div>
		</ViewWithPagination>
	);
}
